export const getMonthAbbreviation = (date: string): string => {
  const dateValue = new Date(date)
  return dateValue.toLocaleString('en-US', { month: 'short' })
}
